<template>
    <div class="joinGropu" v-show="type !== 3">
        <p
            class="btn"
            @click="$refs.community.learnGuideOpen()"
        >
            <img src="@/assets/img/live/addicon.png" alt="">
            {{type === 1 ? '加学习群' : '加助教'}}
        </p>
        <footCommunity 
            ref="community"
            :buyInfo="buyInfo" 
            :iconShow="false"
            @accountType="setType($event)" 
        />
    </div>
</template>
<script>
import footCommunity from '@/pages/courseDetail/courseComponents/footCommunity';

export default {
    data() {
        return {
            courseId:'',
            productSkuId:'',
            type:3
        }
    },
    components:{
        footCommunity
    },
    props:['buyInfo'],
    methods:{
        setType(msg) {
            this.type = msg;
        }
    },
}
</script>
<style scoped lang="scss">
.joinGropu {
    .btn {
        display: flex;
        align-items: center;
        justify-content: center;
        max-width: 200px;
        height: 65px;
        padding: 0 14px;
        color: #FF6C02;
        font-size: 28px;
        background: rgba(255, 108, 2, .1);
        border-radius: 65px;
        img {
            width: 32px;
            height: 32px;
            margin-right: 10px;
        }
    }
}
</style>